import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { StorageProvider } from '../storage/storage';
import { environment } from '../../environment/environment';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class User {
  user: any;

  constructor(public api: Api, private storage: StorageProvider) {}

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    let seq = this.api.post('oauth/new', accountInfo).share();

    seq.subscribe(
      (res: any) => {
        // If the API returned a successful response, mark the user as logged in
        if (res.status == 'success') {
          this._loggedIn(res[0]);
        } else {
        }
      },
      err => {}
    );

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this.user = null;
    this.storage.remove(environment.userKey).then(function(response) {
      // do something
    });
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this.user = resp;
    this.storage.set(environment.userKey, resp);
  }

  _isLoggedIn(): any {
    this.storage.get(environment.userKey).then(function(response) {
      // do something
      if (response && response !== '' && response !== null && response !== undefined) {
        return true;
      } else {
        return false;
      }
    });
  }

  isLoggedIn(): any {
    if (this.user && this.user !== '' && this.user !== null && this.user !== undefined) {
      return true;
    }
    return false;
  }

  get() {
    return this.storage.get(environment.userKey);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts